module.exports = __webpack_public_path__ + "static/tags-based-configuration_2-1debbc0e2f6a407645666f21f262bd73.png";